<template>
  <div class="rt-batch-list">
    <el-table :data="list" stripe border>
      <slot />
      <el-table-column
        label="操作"
        sortable
        prop="operation"
        align="right"
        min-width="120"
      >
        <template slot-scope="scope">
          <div class="operation">
            <rt-button
              v-if="!scope.row.isEdit"
              text
              type="plain"
              @click="edit(scope)"
            >
              编辑
            </rt-button>
            <rt-button v-else text type="plain" @click="add(scope)">
              添加
            </rt-button>
            <rt-popconfirm
              title="确定需要删除这条内容吗？"
              @onConfirm="onConfirm(scope.$index)"
            >
              <rt-button slot="reference" text type="plain">
                删除
              </rt-button>
            </rt-popconfirm>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="footer">
      <div class="add-btn" @click="addBtn">
        <rt-icon name="rt-base-plus" color="#6388c2" />
        <span>添加</span>
      </div>
    </div>
  </div>
</template>

<script>
import RtIcon from '../icon/rtIcon';
import RtButton from '../button/rtButton';
import RtPopconfirm from '../popconfirm/rtPopconfirm';
export default {
  name: 'RtBatchList',
  components: {
    RtIcon,
    RtButton,
    RtPopconfirm
  },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    addNum: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      list: []
    };
  },
  watch: {
    data(newValue) {
      this.$nextTick(() => {
        this.list = JSON.parse(JSON.stringify(newValue));
        this.list.map(item => {
          this.$set(item, 'isEdit', false);
        });
      });
    }
  },
  methods: {
    edit(scope) {
      scope.row.isEdit = true;
    },
    add(scope) {
      scope.row.isEdit = false;
    },
    onConfirm(index) {
      this.del(index);
    },
    del(index) {
      this.list.splice(index, 1);
      let arr = this.list.map(item => {
        let { isEdit, ...data } = item;
        return data;
      });
    },
    addBtn() {
      for (let i = 0; i < this.addNum; i++) {
        this.list.push({ isEdit: true });
      }
    },
    getData() {
      let arr = this.list.filter(item => {
        if (item.isEdit == false) {
          return item;
        }
      });
      let newArr = arr.map(item => {
        let { isEdit, ...data } = item;
        return data;
      });
      return newArr;
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtBatchList.vue?69e7ba7d